import { render, staticRenderFns } from "./truth_h5.vue?vue&type=template&id=14ba559b&scoped=true&"
import script from "./truth_h5.vue?vue&type=script&lang=js&"
export * from "./truth_h5.vue?vue&type=script&lang=js&"
import style0 from "./truth_h5.vue?vue&type=style&index=0&id=14ba559b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba559b",
  null
  
)

export default component.exports